import React, { useContext } from "react";
import styled from "@emotion/styled";
import { motion } from "framer-motion";
import Context from "./Context";
import { Sizes, Animation } from "../../styles";
import JobCard from "./JobCard";
import Pagination from "../pagination/Pagination";
import JobGridNoResults from "./JobGridNoResults";
import Loading from "../Loading";

const renderFeaturedJobCards = (featuredJobItems) => {
	return featuredJobItems.map((item) => {
		return <JobCard key={item.id} jobItem={item} />;
	});
};

const renderJobCards = (jobItems, selectedFilters) => {
	if (jobItems.length === 0 && selectedFilters.length > 0) {
		return <JobGridNoResults text={"No Job items found"} />;
	}
	return jobItems.map((item) => {
		return <JobCard key={item.id} jobItem={item} />;
	});
};

const JobGrid = () => {
	const {
		data: {
			jobItems,
			featuredJobItems,
			totalPages,
			currentPageNumber,
			selectedFilters,
		},
		actions: {
			handleButtonPageSelect,
			handleDecrementPage,
			handleIncrementPage,
		},
		loading,
	} = useContext(Context);

	// only show featured jobs if there are featured jobs added, no filters are selected and we are on the first page
	const showFeaturedJobs =
        featuredJobItems.length > 0 && selectedFilters.length === 0 && currentPageNumber === 1;

	if (loading) {
		return (
			<Container>
				<Loading color={"grey"} />
			</Container>
		);
	}

	return (
		<Container>
			{showFeaturedJobs && (
				<GridContainer>
					<GridContainerTitle
						initial={"initial"}
						animate={"animate"}
						exit={"initial"}
						variants={Animation.cards.opacityVariants}
					>
                        Featured Opportunities
					</GridContainerTitle>
					<Grid isEmpty={featuredJobItems.length === 0}>
						{renderFeaturedJobCards(featuredJobItems)}
					</Grid>
				</GridContainer>
			)}
			<GridContainer>
				{showFeaturedJobs && (
					<GridContainerTitle
						initial={"initial"}
						animate={"animate"}
						exit={"initial"}
						variants={Animation.cards.opacityVariants}
					>
                        All Opportunities
					</GridContainerTitle>
				)}
				<Grid isEmpty={jobItems.length === 0}>{renderJobCards(jobItems, selectedFilters)}</Grid>
			</GridContainer>
			{totalPages && totalPages.length > 1 && (
				<Pagination
					handleDecrementPage={handleDecrementPage}
					handleIncrementPage={handleIncrementPage}
					totalPages={totalPages}
					handleButtonPageSelect={handleButtonPageSelect}
					currentPageNumber={currentPageNumber}
				/>
			)}
		</Container>
	);
};

export default JobGrid;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10rem;
`;

const GridContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2rem;
`;

const GridContainerTitle = styled(motion.h4)``;

const Grid = styled.ul`
    margin: 0;
    padding-left: 0;
    display: ${(props) => (props.isEmpty ? "block" : "grid")};
    grid-template-columns: 1fr;
    gap: 4.6rem;
    max-width: unset;

    @media only screen and (min-width: ${Sizes.screens.medium}) {
        grid-template-columns: repeat(auto-fill, minmax(28.6rem, 1fr));
    }
`;
